export default __webpack_public_path__ + "static/media/edit.4782089b.svg";